const list = {
  endOfResult: 'End of results',
  exportToExcel: 'Export to Excel',
};

export default list;
